import { render, staticRenderFns } from "./LabelTypesView.vue?vue&type=template&id=01bcfeb6"
import script from "./LabelTypesView.vue?vue&type=script&lang=ts"
export * from "./LabelTypesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports